export default {
  AUTH: 'auth',
  EDEX: 'edex',
  DIRECTORY: 'directory',
}
